import * as type from './studyMainActionTypes';

export const getContentByReference = (rate) => ({
  type: type.GET_CONTENT_BY_REFERENCE,
  rate,
});

export const loadQuestionsSKTCounter = (rateId, rank, dutyState) => ({
  type: type.LOAD_SKT_BIBS_COUNTERS,
  rateId,
  rank,
  dutyState,
});

export const getQuestionsByFavoriteQuestions = (
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_FAVORITE,
  stackedQuestions,
  isSetQuestion,
});

export const getQuestionsByMyFavoriteQuestions = (
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_MY_FAVORITE,
  stackedQuestions,
  isSetQuestion,
});

export const getQuestionByMySubmittedQuestions = (
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_MY_SUBMITTED,
  stackedQuestions,
  isSetQuestion,
});

export const getQuestionsBySubmittedQuestions = (
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_SUBMITTED,
  stackedQuestions,
  isSetQuestion,
});

export const setContentByReference = (response) => ({
  type: type.SET_CONTENT_BY_REFERENCE,
  response,
});

export const getPdfByReference = (payload) => ({
  type: type.GET_PDF_BY_REFERENCE,
  payload,
});

export const getPostExamChecklistPdf = () => ({
  type: type.GET_POST_EXAM_CHECKLIST_PDF,
});

export const setPostExamChecklistPdfLink = (response) => ({
  type: type.SET_POST_EXAM_CHECKLIST_PDF_LINK,
  response,
});

export const setIsLoadingPostExamChecklistPdf = (value) => ({
  type: type.SET_IS_LOADING_POST_EXAM_CHECKLIST_PDF,
  value,
});

export const setIsLoadingPdfLink = (value) => ({
  type: type.SET_IS_LOADING_PDF_LINK,
  value,
});
export const setIsLoadingReferences = (value) => ({
  type: type.SET_IS_LOADING_REFERENCES,
  value,
});

export const setIsLoadingSKTData = (value) => ({
  type: type.SET_IS_LOADING_SKT_DATA,
  value,
});

export const setSktCounters = (value) => ({
  type: type.SET_SKT_COUNTERS,
  value,
});
export const setPdfLink = (response) => ({
  type: type.SET_PDF_LINK,
  response,
});

export const setCountQuestions = (value) => ({
  type: type.SET_COUNT_QUESTIONS,
  value,
});

export const addCountQuestions = () => ({
  type: type.ADD_COUNT_QUESTIONS,
});

export const setRecaptchaTime = (value) => ({
  type: type.SET_RECAPTCHA_TIME,
  value,
});

export const getContentByWarfareQuals = (rate) => ({
  type: type.GET_CONTENT_BY_WARFARE_QUALS,
  rate,
});

export const setContentByWarfareQuals = (response) => ({
  type: type.SET_CONTENT_BY_WARFARE_QUALS,
  response,
});

export const getQualById = (qual) => ({
  type: type.GET_QUAL_FROM_ID,
  qual,
});

export const setQualById = (response) => ({
  type: type.SET_QUAL_FROM_ID,
  response,
});

export const getContentByStudyAll = (rate, studyProgram) => ({
  type: type.GET_CONTENT_BY_STUDY_ALL,
  rate,
  studyProgram,
});

export const setContentByStudyAll = (response) => ({
  type: type.SET_CONTENT_BY_STUDY_ALL,
  response,
});

// ---- Question/Answer Flow

export const getQuestionsByRate = (
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_RATE,
  stackedQuestions,
  isSetQuestion,
});

export const setQuestionsByRate = (response) => ({
  type: type.SET_QUESTIONS_BY_RATE,
  response,
});

export const getQuestionsByPersonalizedStudyAll = (
  studyProgram,
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_PERSONALIZED_STUDY_ALL,
  studyProgram,
  stackedQuestions,
  isSetQuestion,
});

export const getQuestionsByQuals = (
  qual,
  studyProgram,
  stackedQuestions,
  isSetQuestion = false,
) => ({
  type: type.GET_QUESTIONS_BY_QUALS,
  qual,
  studyProgram,
  stackedQuestions,
  isSetQuestion,
});

export const setQuestionsByQuals = (response) => ({
  type: type.SET_QUESTIONS_BY_QUALS,
  response,
});

export const getQuestionsByChapter = (
  chapter,
  studyProgram,
  stackedQuestions,
  isSetQuestion,
) => ({
  type: type.GET_QUESTIONS_BY_CHAPTER,
  chapter,
  studyProgram,
  stackedQuestions,
  isSetQuestion,
});

export const setQuestionsByChapter = (response) => ({
  type: type.SET_QUESTIONS_BY_CHAPTER,
  response,
});

export const sendAnswer = (answer) => ({
  type: type.SEND_ANSWER,
  answer,
});

export const favoriteQuestion = (questionId, addToFavorites, userId) => ({
  type: type.FAVORITE_QUESTION,
  addToFavorites,
  questionId,
  userId,
});

export const setAnswerResponse = (response) => ({
  type: type.SET_ANSWER_RESPONSE,
  response,
});

export const cleanQuestions = () => ({
  type: type.CLEAN_QUESTIONS,
});

export const setQuestion = (question, questionsData) => ({
  type: type.SET_QUESTION,
  question,
  questionsData,
});

export const setPreviousQuestion = (question) => ({
  type: type.SET_PREVIOUS_QUESTION,
  question,
});

export const setPreviousCounters = (counters) => ({
  type: type.SET_PREVIOUS_COUNTERS,
  counters,
});

export const setBackedStateToQuestion = () => ({
  type: type.SET_BACKED_STATE_TO_QUESTION,
});

export const previousQuestionToActual = () => ({
  type: type.PREVIOUS_QUESTION_TO_ACTUAL,
});

export const previousCountersToActual = () => ({
  type: type.PREVIOUS_COUNTERS_TO_ACTUAL,
});

export const isStudyPlan = () => ({
  type: type.IS_STUDY_PLAN,
});

export const setCounters = (counters) => ({
  type: type.SET_COUNTERS,
  counters,
});

export const setMoreQuestions = (value) => ({
  type: type.SET_MORE_QUESTIONS,
  value,
});

export const updateCounters = (answer, counterType = null) => ({
  type: type.UPDATE_COUNTERS,
  answer,
  counterType,
});

export const setIsLoadingQuestions = (isLoadingQuestions) => ({
  type: type.SET_IS_LOADING_QUESTIONS,
  isLoadingQuestions,
});

export const setErrorMessageGetQuestions = (errorMessage) => ({
  type: type.MESSAGE_ERROR_GET_QUESTIONS,
  errorMessage,
});

export const setBackTo = (backTo) => ({
  type: type.SET_BACK_TO,
  backTo,
});

export const setChapterId = (value) => ({
  type: type.SET_CHAPTER_ID,
  value,
});

export const updateUserAnswers = (value) => ({
  type: type.UPDATE_USERANSWERS,
  value,
});

export const checkChapterInReviewAction = (value) => ({
  type: type.CHECK_CHAPTER_IN_REVIEW,
  value,
});

export const breadcrumsAction = (breadcrums) => ({
  type: type.BREADCRUMS_QUALS_AND_CERTS,
  breadcrums,
});

export const loadFavoriteQuestion = (status) => ({
  type: type.LOAD_FAVORITE_QUESTION,
  status,
});

export const setFavoriteMessage = (status) => ({
  type: type.SET_FAVORITE_MESSAGE,
  status,
});

export const setIsStudyFavoriteQuestion = (status) => ({
  type: type.SET_IS_STUDY_FAVORITE_QUESTION,
  status,
});

export const setCounterFavorite = (response) => ({
  type: type.SET_COUNTER_FAVORITE,
  response,
});

export const setCounterMyFavorite = (response) => ({
  type: type.SET_COUNTER_MY_FAVORITE,
  response,
});

export const setCounterMySubmitted = (response) => ({
  type: type.SET_COUNTER_MY_SUBMITTED,
  response,
});

export const setCounterSubmitted = (counters) => ({
  type: type.SET_COUNTER_SUBMITTED,
  counters,
});

export const setSubmittedQuestions = (questions) => ({
  type: type.SET_SUBMITTED_QUESTIONS,
  questions,
});

export const setFavoriteQuestionsForStudy = (questions) => ({
  type: type.SET_FAVORITE_QUESTIONS_FOR_STUDY,
  questions,
});

export const setIsStudyingSubmittedQuestions = (status) => ({
  type: type.SET_IS_STUDYING_SUBMITTED_QUESTIONS,
  status,
});

export const setIsStudyingMyFavoriteQuestions = (status) => ({
  type: type.SET_IS_STUDYING_MY_FAVORITE_QUESTIONS,
  status,
});

export const resetChapterAction = (value) => ({
  type: type.RESET_CHAPTER,
  value,
});

export const resetChapterMessagge = (message) => ({
  type: type.SET_RESET_CHAPTER_MESSAGE,
  message,
});

export const loadResetChapter = (value) => ({
  type: type.LOAD_RESET_CHAPTER,
  value,
});

export const setResetChapter = (value) => ({
  type: type.SET_RESET_CHAPTER,
  value,
});

export const setIsStudyingMySubmittedQuestions = (status) => ({
  type: type.SET_IS_STUDYING_MY_SUBMITTED_QUESTIONS,
  status,
});

export const updateDisabledChapter = (chapterId, userId) => ({
  type: type.UPDATE_DISABLED_CHAPTER,
  chapterId,
  userId,
});

export const getAudioPlaylist = (chapterId) => ({
  type: type.GET_AUDIO_PLAYLIST,
  chapterId,
});
export const setAudioPlaylist = (audio) => ({
  type: type.SET_AUDIO_PLAYLIST,
  audio,
});

// Format from the API: progressByChapter = [{chapterId, nextQuestionId, status, accumulated, total}, ...]
export const addAudioPlaylistsProgress = (progressByChapter) => ({
  type: type.ADD_AUDIO_PLAYLISTS_PROGRESS,
  payload: {
    progressByChapter,
  },
});
export const getAudioPlaylistsProgress = (chapterIds) => ({
  type: type.GET_AUDIO_PLAYLISTS_PROGRESS,
  payload: {
    chapterIds,
  },
});
export const updateAudioPlaylistProgress = (
  chapterId,
  nextQuestionId,
  status,
  restartPlaylist = false,
) => ({
  type: type.UPDATE_AUDIO_PLAYLIST_PROGRESS,
  payload: {
    chapterId,
    nextQuestionId,
    status,
    restartPlaylist,
  },
});
